import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { compose, withProps, flattenProp } from 'recompose';

import StopIcon from 'modules/journey/Stop/StopIcon';
import StopComments from 'modules/journey/Stop/StopComments';
import TimeRange from 'components/TimeRange';
import StopExtras from 'modules/journey/Stop/StopExtras';
import moment from 'moment';
import { Spacer, Tag } from '@ontruck/orc';

import { StyledCell, StyledLabel, StyledSubLabel } from './styled';

const t = {
  diff_days: '{number, plural, one {+{number} day} other {+{number} days}}',
};

const enhance = compose(
  flattenProp('stop'),
  withProps(({ address }) => ({
    addressLabel: address.label,
  }))
);

const StopCell = React.memo(
  ({
    extras,
    firstStopTimeFrom,
    cellWidth,
    time_from,
    stop_type,
    addressLabel,
    comments,
    time_to,
  }) => {
    const firstTimeMoment = moment(firstStopTimeFrom).startOf('day');
    const stopTimeMoment = moment(time_from).startOf('day');
    const diff = moment.duration(stopTimeMoment.diff(firstTimeMoment)).asDays();

    return (
      <StyledCell cellWidth={cellWidth}>
        <StyledLabel title={addressLabel}>
          <StopIcon stop_type={stop_type} /> {addressLabel}
        </StyledLabel>
        <StyledSubLabel>
          <StopComments comments={comments} mRight="XS" />
          <TimeRange from={time_from} to={time_to} />
          {!!diff && (
            <Spacer mLeft="XS">
              <Tag
                text={
                  <FormattedMessage
                    id="diff_days"
                    defaultMessage={t.diff_days}
                    values={{
                      number: String(diff),
                    }}
                  />
                }
                size="S"
                skin="dark"
                textTransform="uppercase"
              />
            </Spacer>
          )}
          <Spacer mLeft="XS">
            <StopExtras extras={extras} iconSize="18" />
          </Spacer>
        </StyledSubLabel>
      </StyledCell>
    );
  }
);

StopCell.propTypes = {
  time_from: PropTypes.string.isRequired,
  time_to: PropTypes.string.isRequired,
  addressLabel: PropTypes.string.isRequired,
  stop_type: PropTypes.string.isRequired,
  comments: PropTypes.array.isRequired,
  extras: PropTypes.array.isRequired,
  firstStopTimeFrom: PropTypes.string.isRequired,
  cellWidth: PropTypes.number,
};

export default enhance(StopCell);
